import { FC } from "react";

import { Info } from "@livechat/design-system-icons";
import { Button, DesignToken, Icon } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import Text from "components/layout/Text";
import { withVar } from "themes/helpers";

interface IProps {
  title: React.ReactNode | string;
  firstActionText?: string;
  firstActionOnClick?: () => void;
  secondActionText?: string;
  secondActionOnClick?: () => void;
  disableActions?: boolean;
  isAgent?: boolean;
  dataTestId?: string;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const VerticalSeparator = () => (
  <Flex width="1px" height="20px" bg={withVar(DesignToken.BorderBasicSecondary)} marginH="8px" />
);

const ToolbarLabel: FC<IProps> = ({
  title,
  firstActionText,
  firstActionOnClick,
  secondActionText,
  secondActionOnClick,
  disableActions,
  isAgent,
  dataTestId,
}) => (
  <Flex alignItems="flex-start" gap="8px" minHeight="32px" data-testid={dataTestId}>
    <Block paddingV="8px">
      <Icon source={Info} size="small" />
    </Block>
    <Flex flexWrap alignItems="center">
      <Text
        fontSize="14px"
        lineHeight="20px"
        color={withVar(DesignToken.ContentBasicSecondary)}
        paddingV="6px"
        marginRight="8px"
      >
        {title}
      </Text>
      <Flex alignItems="center">
        {firstActionText && (
          <Button kind="plain" size="compact" onClick={firstActionOnClick} disabled={disableActions}>
            {firstActionText}
          </Button>
        )}

        {!isAgent && secondActionText && (
          <>
            <VerticalSeparator />
            <Button kind="plain" size="compact" onClick={secondActionOnClick} disabled={disableActions}>
              <Text
                color={withVar(disableActions ? DesignToken.ContentBasicDisabled : DesignToken.ContentBasicNegative)}
              >
                {secondActionText}
              </Text>
            </Button>
          </>
        )}
      </Flex>
    </Flex>
  </Flex>
);

export default ToolbarLabel;
